// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_1b5abcf4","outerContainer":"_1639a124","secondaryToolbar":"_412fa10a","doorHangerRight":"_4db1322d","toolbarContainer":"_43ff5d24","toolbarViewerMiddle":"_8f50666c","progressBar":"_398410e3","back-to-application":"_8aea4f06","video-btn":"_2d0d9f7b","primary":"fe9eb74b","disabled":"b92d269c","accent":"_788da6e1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Healthboard/Components/VideoVisitBtn/styles.styl
// module id = 4984
// module chunks = 39